const config = {
  'enter-amount': {
    pageName: 'enterAmount',
    uri: '/',
  },
  'payroll-review-di': {
    pageName: 'loanReview',
    uri: '/review',
  },
  'payroll-review': {
    pageName: 'loanReview',
    uri: '/review',
  },
  'loan-success': {
    pageName: 'loanSuccess',
    uri: '/success',
  },
  'timeout': {
    pageName: 'timeout',
    uri: '/timeout',
  },
  'error': {
    pageName: 'errorPage',
    uri: '/error',
  },
  'loading': {
    pageName: 'processing',
  },
};

Object.entries(config).forEach(([key, val]) => {
  val.key = key;
});

export default config;
